// The rules for text a customer sends back to the run: message drafts,
// question answers, and edited approvals. Views use them to gate a submit
// and explain a disabled action; the outbox reuses the same limits.
export const MESSAGE_CHARACTER_LIMIT = 20_000;
export const SMS_MESSAGE_CHARACTER_LIMIT = 1_600;
export const VOICE_INSTRUCTIONS_CHARACTER_LIMIT = 2_000;
export const VOICE_OPENING_LINE_CHARACTER_LIMIT = 1_600;

export type DraftIssue =
    | Readonly<{ readonly kind: 'empty' }>
    | Readonly<{
          readonly kind: 'too_long';
          readonly count: number;
          readonly limit: number;
      }>;

export function draftIssue(
    value: string,
    options: Readonly<{ readonly limit: number; readonly required?: boolean }>,
): DraftIssue | null {
    const count = Array.from(value.trim()).length;
    if (count === 0) {
        return options.required === false ? null : { kind: 'empty' };
    }
    if (count > options.limit) {
        return { kind: 'too_long', count, limit: options.limit };
    }
    return null;
}

export function draftIssueCopy(issue: DraftIssue, label: string): string {
    switch (issue.kind) {
        case 'empty':
            return `${label} is empty`;
        case 'too_long':
            return `${issue.count.toLocaleString('en-US')} of ${issue.limit.toLocaleString('en-US')} characters`;
        default: {
            const exhaustiveIssue: never = issue;
            return exhaustiveIssue;
        }
    }
}
